// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { ImageTokens } from './type';

const imageTokens: ImageTokens = {
  imageSpinColor: 'Neutral-text-2',
  imageBorderRadius: 'Radius-default',
  imageBorderColor: 'Neutral-border-1',
  imageCircleBorderRadius: 'Radius-circle',
  imageCircleBorderColor: 'Neutral-border-1',
  imageRoundedBorderRadius: 'Radius-default',
  imageRoundedBorderColor: 'Neutral-border-1',
  imageThumbnailBorderRadius: 'Radius-default',
  imageThumbnailBorderColor: 'Neutral-border-1',
  imagePlaceholderBackgroundColor: 'Neutral-fill-2',
  imageErrorBackgroundColor: 'Neutral-fill-2',
  imageErrorFontColor: 'Neutral-text-4',
  imageErrorFontSize: 'Font-12',
  imageGroupNearlyMargin: 'Spacing-8',
  imageMaskBackgroundColor: 'Mask-fill-1',
  imageBackgroundColor: 'Neutral-fill-2',
};

export default imageTokens;
